export default {
    last: '最後へ',
};
